import { getContext } from '@fiverr-private/fiverr_context';
import { inExperiment } from '../index';
import { LYNXES_GIG_PAGE_CTA_REWORK } from '../experimentsEnum';
import { ROLLOUTS } from '../../../types/rollouts';

/**
 * Checks if user is in the Lynxes CTA Rework test
 * @returns {boolean} true if user is in experiment and rollout is active
 */
export const isInLynxesCtaReworkTest = (rollouts: Record<string, boolean>) => {
    const { abTests } = getContext();

    if (!rollouts[ROLLOUTS.LYNXES_GIG_PAGE_CTA_REWORK]) {
        return false;
    }

    return inExperiment(LYNXES_GIG_PAGE_CTA_REWORK, abTests);
};
